<template>
  <section
    :class="[$style.login, $style.fullscreen]"
    :style="{
      backgroundImage: 'url(\'resources/images/fondo-aol.jpg\')'
    }"
  >
    <header :class="$style.header">
      <a href="javascript: void(0);" :class="$style.logo">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
        />
      </a>
      <!--
      <div :class="$style.styleControls">
        <a-button class="mt-3 mt-xl-0" @click="setFullscreen"
          >Set {{ fullscreen ? "Windowed" : "Fullscreen" }}</a-button
        >
        <a-button class="ml-3 mt-3 mt-xl-0" @click="changeBackground"
          >Change Background</a-button
        >
      </div>
      -->
      <nav :class="$style.loginNav">
        <ul :class="$style.navItems">
          <li>
            <a-button type="link" @click="goBack()">&larr; Volver</a-button>
          </li>
          <!--
          <li>
            <a :class="$style.active" href="javascript: void(0);">Login</a>
          </li>
          <li>
            <a href="javascript: void(0);">About</a>
          </li>
          <li>
            <a href="javascript: void(0);">Support</a>
          </li>
          -->
        </ul>
      </nav>
    </header>
    <div :class="$style.content">
      <div :class="$style.promo">
        <h1 class="mb-3 text-white">Actualización de Medio de Pago</h1>
        <p>
          Para cambiar el medio de pago de tu suscripción ingresa los datos<br />
          de tu tarjeta. Si tu suscripción está inactiva se reactivará.
        </p>
      </div>

      <div :class="$style.formWrapper">
        <div :class="$style.form" v-if="subscriptionError">
          <p :class="$style.formTitle">
            Hubo un error al cargar la subscripción. <br /><span
              style="font-size:12px"
              >Por favor, volver atrás y volver a intentar.</span
            >
          </p>
          <div class="login-form">
            <a-button type="primary" @click="goBack()"
              ><a-icon type="left" /> Volver
            </a-button>
          </div>
        </div>
        <div :class="$style.form" v-else>
          <p :class="$style.formSubtitle" style="margin-left:0.5rem;">
            DATOS DE PAGO
          </p>

          <payment-form
            v-if="subscription"
            ref="paymentFormComponent"
            :mode="'2-step'"
            :showPrice="true"
            :showInstallments="false"
            :publicKey="subscription.account.publicKey"
          />
          <vue-recaptcha
            sitekey="6Lf47sUUAAAAAHzkc0paHmaLsN2kUA_5pv2ZIDwi"
            :loadRecaptchaScript="true"
            @verify="handleRecaptchaVerified"
            style="margin-top: 1rem"
          >
          </vue-recaptcha>

          <div class="form-actions">
            <a-button
              @click="handleSubmit"
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoader"
              size="large"
              icon="lock"
            >
              SUSCRIBIRME
            </a-button>
          </div>
        </div>
        <div :class="$style.sidebar">
          <div :class="$style.promoMobile">
            <h1 class="mb-3 text-white">
              Actualización<br />
              de Medio de Pago
            </h1>
            <p>
              Para cambiar el medio de pago de tu suscripción ingresa los datos
              de tu tarjeta. Si tu suscripción está inactiva se reactivará.
            </p>
          </div>
          <p :class="$style.sidebarTitle">
            {{ subscription.name }}
            <!--<span v-if="scStatus == 1" title="Suscripción Activa">
              <a-icon
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
                style="fontSize: 14px"
              ></a-icon>
            </span>
            <span
              v-else-if="scStatus == 5"
              title="Suscripción en período de pruebas"
              ><a-icon
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
                style="fontSize: 14px"
              ></a-icon
            ></span>
            <span
              v-else-if="scStatus == 2 || scStatus == 3"
              title="La suscripción esta inactiva"
              ><a-icon
                type="pause-circle"
                theme="twoTone"
                two-tone-color="#eb2f96"
                style="fontSize: 14px"
              ></a-icon
            ></span>-->
          </p>

          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <strong>Precio:</strong>
            ${{ subscription.amount }}
            <span v-if="subscription.account.gatewayId == 1"> ARS </span>
            <span v-else-if="subscription.account.gatewayId == 2"> USD </span> /
            <span v-if="subscription.frequencyId == 1">mes</span>
            <span v-if="subscription.frequencyId == 2">año</span>
            <br />
            <span v-if="subscription.freeTrialDays" style="font-weight:bold"
              >{{ subscription.freeTrialDays }} días de prueba sin cargo</span
            >
          </p>
          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <i class="icmn-user mr-3" /> Usuario: <br />
            <span v-if="customer.firstName != customer.email"
              >{{ customer.firstName }} {{ customer.lastName }}</span
            >
            {{ customer.email }}
            <span v-if="customer.phone1"
              ><br />
              Tel: {{ customer.phone1 }}
            </span>
          </p>
          <!-- <div :class="$style.sidebarFooter" style="margin-bottom:1rem">
            <span>
              <i class="icmn-location mr-3" />
              {{ sellerUserId }}
            </span>
          </div> -->
          <div :class="$style.sidebarContent">
            <p>
              <strong>Términos y Condiciones:</strong><br />
              <span v-if="subscription.account.gatewayId == 1">
                Los datos ingresados son procesados directamente por el gateway
                de pagos Decidir Prisma<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
              <span v-else>
                Los datos ingresados son procesados directamente por la pasarela
                de pagos Páguelo Fácil<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer :class="$style.footer" style="text-align:center; margin-top:5rem">
      <span style="color:#ccc;">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
          width="120"
        /><br />
        <!-- Darregueyra 2390, Palermo Buenos Aires, Argentina.<br /> -->
        <a href="https://elartedevivir.org" target="_blank">elartedevivir.org</a
        ><br />
        Darregueyra 2390, Ciudad Autónoma de Buenos Aires, Argentina.
      </span>
      <!--<ul :class="$style.footerNav">
        <li>
          <a href="javascript: void(0);">Términos y Condiciones</a>
        </li>
        <li>
          <a href="javascript: void(0);">Compliance</a>
        </li>
        <li>
          <a href="javascript: void(0);">Confidencialidad</a>
        </li>
        <li>
          <a href="javascript: void(0);">Soporte</a>
        </li>
        <li>
          <a href="javascript: void(0);">Contacto</a>
        </li>
      </ul>-->
    </footer>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
import VueRecaptcha from "vue-recaptcha";
import utils from "@/services/utils";
import PaymentForm from "@/components/PaymentForm";

export default {
  data: function() {
    return {
      linkToken: this.$route.params.linkToken,
      form: this.$form.createForm(this),
      loading: false,
      subscription: {},
      customer: {},
      submitLoader: false,
      subscriptionError: false,
      recaptchaKey: null,
      scStatus: null
      //fullscreen: false,
      //backgroundNumber: 1
    };
  },
  components: { PaymentForm, VueRecaptcha },
  methods: {
    ...mapActions({
      loadSubscriber: "subscriberPaymentEditLink/load",
      editPaymentMethod: "subscriberPaymentEditLink/editPaymentMethod"
    }),
    handleRecaptchaVerified(key) {
      this.recaptchaKey = key;
    },
    async handleSubmit(e) {
      //e.preventDefault();
      this.submitLoader = true; //local loader button

      const paymentFormPayload = await this.$refs.paymentFormComponent.handleSubmit();

      if (paymentFormPayload) {
        if (!this.recaptchaKey) {
          this.$notification["warning"]({
            message: "Error",
            description: "Por favor, hacer click en el botton de Recaptcha."
          });
        } else {
          try {
            this.submitLoader = true;
            const res = await this.editPaymentMethod({
              paymentFormPayload,
              linkToken: this.linkToken,
              recaptcha: this.recaptchaKey
            });
            this.submitLoader = false;
            this.$notification["success"]({
              message: res.message //"La suscripción fue procesada con éxito."
            });
            if (this.subscription.successfulPaymentURL) {
              //alert(this.subscription.successfulPaymentURL);
              window.location.href = `${this.subscription.successfulPaymentURL}`;
            }
          } catch (err) {
            let description;
            if (err.message) description = err.message;
            else
              description =
                "Error al modificar la forma de pago. Por favor, intente nuevamente.";
            this.submitLoader = false;
            this.$notification["warning"]({
              message: "Error",
              description: description
            });
          }
        }
      }
      this.submitLoader = false; //local loader button
    },
    goBack() {
      window.history.back();
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async created() {
    try {
      const res = await this.loadSubscriber(this.$route.params.linkToken);
      this.subscription = store.state.subscriberPaymentEditLink.subscription;
      store.state.paymentForm.subtotal = this.subscription.amount;
      this.customer = store.state.subscriberPaymentEditLink.customer;
      this.scStatus = store.state.subscriberPaymentEditLink.scStatus;
    } catch (error) {
      this.subscriptionError = true;
      this.$notification["warning"]({
        message: "Error",
        description: error.message
      });
    }
  },
  mounted() {
    this.$refs.initial.$el.children[1].focus(); //focus 1st input on page load.
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style>
.ant-input {
  height: inherit !important;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
</style>
